module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/vegetarian@3x__445c60106532667c0cece81a658e9955.png";